'use client';

import { CheckboxField, Tooltip } from '@petsmart-ui/sparky';

import './KeepSignedInCheckbox.scss';
import { useState } from 'react';
import { REMEMBER_ME_SESSION_STORAGE_KEY } from '@libs/core/constants';

export default function KeepSignedInCheckbox() {
    const [rememberMe, setRememberMe] = useState(
        window.sessionStorage.getItem(REMEMBER_ME_SESSION_STORAGE_KEY) === 'true'
    );

    return (
        <div className="keep-signed-in__field">
            <CheckboxField hideLegend label="Keep me signed in checkbox">
                <CheckboxField.Item
                    key="keekSignedIn"
                    text="Keep me signed in"
                    name="keekSignedIn"
                    checked={rememberMe}
                    onChange={(value: boolean) => {
                        setRememberMe(value);
                        window.sessionStorage.setItem(REMEMBER_ME_SESSION_STORAGE_KEY, value.toString());
                    }}
                />
            </CheckboxField>

            <Tooltip enableHover data-testid="keep-signed-in--tooltip">
                By checking this box, we’ll remember you on this device. You’ll still sign in for secure actions. For
                security, use only on personal devices.
            </Tooltip>
        </div>
    );
}
